"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Util = exports.EPSILON = void 0;
exports.swap = swap;
exports.hypot = hypot;
exports.clamp = clamp;
exports.EPSILON = 2.220446049250313e-16;
function swap(A, i0, i1, t) {
    t = A[i0];
    A[i0] = A[i1];
    A[i1] = t;
}
function hypot(a, b) {
    a = Math.abs(a);
    b = Math.abs(b);
    if (a > b) {
        b /= a;
        return a * Math.sqrt(1.0 + b * b);
    }
    if (b > 0) {
        a /= b;
        return b * Math.sqrt(1.0 + a * a);
    }
    return 0.0;
}
/**
 * Clamp number within bounds.
 * @returns `low` <= `value` <= `high`
 */
function clamp(value, low, high) {
    if (low > high) {
        throw new Error(`Cannot clamp if low (${low}) > high (${high})`);
    }
    if (value < low) {
        return low;
    }
    if (value > high) {
        return high;
    }
    return value;
}
exports.Util = {
    swap,
    hypot,
    clamp
};
//# sourceMappingURL=util.js.map